import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import StayInLoop from "../components/StayInLoop";
import RequestDemoBox from "../components/RequestDemoBox";

export default function RequestDemo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: "70vh", md: "70vh" },
          overflow: "hidden",
          padding: "60px 24px",
          margin: "auto",
          maxWidth: "1250px",
        }}
      >
        {/* Background Video */}
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: -1,
            overflow: "hidden",
          }}
        >
          <video
            autoPlay
            loop
            muted
             playsInline
  preload="metadata"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          >
            <source src="/HomeBGVideo.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </Box>

        {/* Content Overlay */}

        <Grid container spacing={{ xs: 4, sm: 6, md: 12 }}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              width: "80%",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                background:
                  "linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "center",
                letterSpacing: isMobile ? "0px" : "-2.4px",
                display: "flex",
                justifyContent: "center",
                mt: {xs:2,md:4},
              }}
            >
              Let’s Connect and Collaborate!
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 400,
                  color: "#8C8CC2",
                  textAlign: "center",
                  mt: {xs:2,md:4},
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: {xs:4,md:8}
                }}
              >
                Have questions or need assistance? Reach out to us, and our team
                will be happy to help you find the perfect solution.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <RequestDemoBox  />
      </Box>
     
    </>
  );
}
